import { render } from "./ArtikelAdmin.vue?vue&type=template&id=4f99129f"
import script from "./ArtikelAdmin.vue?vue&type=script&lang=js"
export * from "./ArtikelAdmin.vue?vue&type=script&lang=js"

import "./ArtikelAdmin.vue?vue&type=style&index=0&id=4f99129f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__